export const RecipeOptions = {
  bindings: {
    serves: '<',
    variations: '<',
    prepTime: '<',
    cookingTime: '<',
    calories: '<',
    isMarinated: '<',
    onClickVariation: '&',
  },

  template: `
    <div class="d-flex justify-content-between bg-gray-100 border border-y border-gray-300 py-3 px-3">
      <small ng-if="!$ctrl.variations || $ctrl.variations.length <= 1">
        <i class="fa-lg icon-serves text-pink-cz-mid"></i>
        x{{ $ctrl.serves }}
      </small>
      <small ng-if="$ctrl.variations && $ctrl.variations.length > 1">
        <button class="btn btn-link dropdown-toggle d-flex align-items-center p-0 border-0"
          type="button"
          data-toggle="dropdown">
          <small>
            <i class="fa-lg icon-serves mr-1 text-pink-cz-mid"></i>
            x{{ $ctrl.serves }}
          </small>
        </button>
        <div class="dropdown-menu mt-2">
          <a class="dropdown-item"
            href="#"
            ng-click="$ctrl.onClickVariation({ recipeId: item.id })"
            ng-repeat="item in $ctrl.variations">
            x{{ item.serves }}
          </a>
        </div>
      </small>
      <small ng-if="$ctrl.prepTime">
        <i class="fa-lg icon-prep-time text-pink-cz-mid"></i>
        {{ $ctrl.prepTime }}
        <span class="unit">
          m<span class="d-none d-md-inline-block">in prep</span>
        </span>
      </small>
      <small ng-if="$ctrl.cookingTime">
        <i class="fa-lg icon-cook-time text-pink-cz-mid"></i>
        {{ $ctrl.cookingTime }}
        <span class="unit">
          m<span class="d-none d-md-inline-block">in cooking</span>
        </span>
      </small>
      <small ng-if="$ctrl.calories">
        <i class="fa-lg icon-calories text-pink-cz-mid"></i>
        {{ $ctrl.calories }}
        <span class="unit">
          Cal<span class="d-none d-md-inline-block"> / serve</span>
        </span>
      </small>
      <small ng-if="$ctrl.isMarinated">
        <i class="fa-lg icon-time"></i>
        <span class="unit">Marinating required</span>
      </small>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Recipe/RecipeOptions.js